import React, { useRef, useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import LoadingSpinner from "../../Loading/component";
import varifiedIcon from "../../../assests/verifiedIcon.svg";
import './Productcategory.css';

const CategoryCreateComponent = ({
  formData = { name: '', description: '', active: true },
  setFormData,
  iconPreview = '',
  bgPreview = '',
  useTransparentBg = false,
  variantIds = [],
  variantDetails = {},
  inputValue = '',
  setInputValue = () => {},
  iconInputRef,
  backgroundInputRef,
  isFormValid = false,
  isSubmitting = false,
  isIconUploading = false,
  isBgUploading = false,
  showSuccessPopup = false,
  setShowSuccessPopup = () => {},
  handleToggleTransparent = () => {},
  handleAddId = () => {},
  removeId = () => {},
  handleClearAllVariants = () => {},
  handleBackClick = () => {},
  handleSave = () => {},
  handleIconFileSelect = () => {},
  handleBgFileSelect = () => {},
  handleClearIcon = () => {},
  handleClearBg = () => {},
  iconPath = '',
  bgPath = '',
  createdItemName = '',
  createdItemId = '',
  isVerifying = false,
}) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (active) => {
    setFormData(prev => ({ ...prev, active }));
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      handleIconFileSelect({ target: { files: [file] } });
    }
  };

  // S3 Base URL
  const S3_BASE_URL = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";

  const getVariantImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith("http")) return imagePath;
    return `${S3_BASE_URL}${imagePath.replace(/^\//, '')}`;
  };

  return (
    <div className="category-create-container">
      <Sidebar />
      
      {isSubmitting && (
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      )}
      
      <div className="category-create-content">
        <div className="category-create-header">
          <button className="create-back-btn" onClick={handleBackClick} type="button">
            ←
          </button>
          <h1>Create Category</h1>
        </div>

        <div className="category-create-wrapper">
          <div className="category-create-card">
            <div className="category-create-inner">
              {/* Category Name Field */}
              <div className="create-form-group">
                <label className="create-form-label">
                  Category Name <span className="create-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData?.name || ''}
                  onChange={handleInputChange}
                  placeholder="Eg. Fresh Food, Electronics, Snacks"
                  className="create-form-input"
                  autoComplete="off"
                />
              </div>

              {/* Description Field */}
              <div className="create-form-group">
                <label className="create-form-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData?.description || ''}
                  onChange={handleInputChange}
                  placeholder="Key details about this category"
                  className="create-form-textarea"
                  rows="3"
                  autoComplete="off"
                />
              </div>

              {/* Image Upload Field */}
              <div className="create-form-group">
                <label className="create-form-label">Image</label>
                <div 
                  className={`create-image-upload-area ${dragActive ? 'create-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                  style={{ cursor: 'pointer' }}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleIconFileSelect}
                  />
                  {iconPreview ? (
                    <div className="create-image-preview-container">
                      <img src={iconPreview} alt="Image Preview" className="create-image-preview" />
                      <button 
                        type="button"
                        className="create-remove-image-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClearIcon();
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="create-upload-placeholder">
                      <div className="create-upload-icon">📤</div>
                      <p className="create-upload-text">
                        <span className="create-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="create-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
                {isIconUploading && (
                  <div className="create-uploading-indicator">
                    <div className="spinner-small"></div>
                    <span>Uploading image...</span>
                  </div>
                )}
              </div>

              {/* Status Buttons */}
              {/* <div className="create-status-section">
                <div className="create-status-buttons">
                  <button
                    type="button"
                    onClick={() => handleStatusChange(true)}
                    className={`create-status-btn ${formData.active === true ? 'create-status-active' : ''}`}
                  >
                    ACTIVE
                  </button>
                  <button
                    type="button"
                    onClick={() => handleStatusChange(false)}
                    className={`create-status-btn ${formData.active === false ? 'create-status-inactive' : ''}`}
                  >
                    INACTIVE
                  </button>
                </div>
              </div> */}

              {/* Submit Button */}
              <div className="create-form-actions">
                <button 
                  type="button"
                  onClick={handleSave}
                  className={`create-category-btn ${isFormValid ? 'create-active' : 'create-disabled'}`}
                  disabled={!isFormValid || isSubmitting}
                >
                  {isSubmitting ? 'Creating...' : 'Create Category'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="category-success-overlay">
          <div className="category-success-modal">
            <div className="cat-attr-success-icon">
              <img src={varifiedIcon} alt="success" />
            </div>
            <h3 className="category-success-title">Created Successfully!</h3>
            <p className="category-success-message">Category has been created successfully.</p>
            <div className="category-success-details">
              <div className="category-success-detail-row">
                <span className="category-success-label">Name:</span>
                <span className="category-success-value">{createdItemName}</span>
              </div>
              <div className="category-success-detail-row">
                <span className="category-success-label">ID:</span>
                <span className="category-success-value">{createdItemId}</span>
              </div>
            </div>
            <button className="category-success-btn" onClick={() => setShowSuccessPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryCreateComponent;